import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class DomesticHotWaterCirculationPump implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES: ' 62 01 F1 00 00 00 00 05',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0020_HPMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterCirculationPump,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'DomesticHotWaterCirculationPumpMode',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENUMCHOICE',
              path: 'PA_DataRecor/PA_CircuPumpMode',
              unit: '',
              translationid: 'TI_CirculationPumpMode',
              dopname: '1 Byte TextTable DomesticHotWaterCirculationPumpMode',
              name: 'PA_CircuPumpMode',
              value: 'TimeScheduled',
            },
            {
              semantic: 'BOOLEANCHOICE',
              path: 'PA_DataRecor/PA_ParalLegio',
              unit: '',
              translationid: 'TI_ParallelLegion',
              dopname: '1 Byte TextTable NoYes',
              name: 'PA_ParalLegio',
              value: 'No',
            },
            {
              semantic: 'BOOLEANCHOICE',
              path: 'PA_DataRecor/PA_ParalDomesHotWater',
              unit: '',
              translationid: 'TI_ParallelDomesticHotWater',
              dopname: '1 Byte TextTable NoYes',
              name: 'PA_ParalDomesHotWater',
              value: 'No',
            },
            {
              semantic: 'ENUMCHOICE',
              path: 'PA_DataRecor/PA_CycleConfi',
              unit: '',
              translationid: 'TI_CycleConfiguration',
              dopname: '1 Byte TextTable CycleConfiguration',
              name: 'PA_CycleConfi',
              value: 'OneCycle',
            },
            {
              semantic: 'VALUEWRITE',
              path: 'PA_DataRecor/PA_TriggCycleDurat',
              unit: 'min',
              translationid: 'TI_TriggerCycleDuration',
              dopname: '1 Byte Identical uint8 Minute',
              name: 'PA_TriggCycleDurat',
              value: '5',
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 F1',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.DomesticHotWaterCirculationPump,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '491',
          value: 'DomesticHotWaterCirculationPump',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'DEFVALUE',
              longname: 'DefValue',
              byteposition: '0',
              dopname: '1 Byte TextTable OffOn',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_DefValue',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_Off', interval: '0', texttableentry: 'Off' },
                { TI_texttableentry: 'TI_On', interval: '1', texttableentry: 'On' },
                {
                  TI_texttableentry: 'TI_OutOfRange',
                  interval: '2',
                  texttableentry: 'OutOfRange',
                },
              ],
              path: 'PA_Value/PA_DefValue',
              unit: '',
              translationid: 'TI_DefValue',
              bitposition: '0',
              name: 'PA_DefValue',
              value: 'Off',
            },
            {
              semantic: 'LOWLOWLEVEL',
              longname: 'LowLowLevel',
              byteposition: '1',
              dopname: '1 Byte Identical uint8 Percent',
              precision: '',
              byteLength: '8',
              type: 'eA_UINT32',
              shortname: 'PA_LowLowLevel',
              constraints: '[0:255]',
              path: 'PA_Value/PA_LowLowLevel',
              unit: '%',
              translationid: 'TI_LowLowLevel',
              bitposition: '0',
              name: 'PA_LowLowLevel',
              value: '0',
            },
            {
              semantic: 'DEFLEVEL',
              longname: 'DefLevel',
              byteposition: '2',
              dopname: '1 Byte Identical uint8 Percent',
              precision: '',
              byteLength: '8',
              type: 'eA_UINT32',
              shortname: 'PA_DefLevel',
              constraints: '[0:255]',
              path: 'PA_Value/PA_DefLevel',
              unit: '%',
              translationid: 'TI_DefLevel',
              bitposition: '0',
              name: 'PA_DefLevel',
              value: '0',
            },
            {
              semantic: 'HIGHHIGHLEVEL',
              longname: 'HighHighLevel',
              byteposition: '3',
              dopname: '1 Byte Identical uint8 Percent',
              precision: '',
              byteLength: '8',
              type: 'eA_UINT32',
              shortname: 'PA_HighHighLevel',
              constraints: '[0:255]',
              path: 'PA_Value/PA_HighHighLevel',
              unit: '%',
              translationid: 'TI_HighHighLevel',
              bitposition: '0',
              name: 'PA_HighHighLevel',
              value: '100',
            },
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '4',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'True',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0020_HPMU_CAN01',
          request_parameter_value: VddNames.DomesticHotWaterCirculationPump,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '497',
              value: 'DomesticHotWaterCirculationPumpMode',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENUMCHOICE',
                  longname: 'CirculationPumpMode',
                  byteposition: '0',
                  dopname: '1 Byte TextTable DomesticHotWaterCirculationPumpMode',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_CircuPumpMode',
                  constraints: '',
                  structure: [
                    {
                      TI_texttableentry: 'TI_TimeScheduled',
                      interval: '0',
                      texttableentry: 'TimeScheduled',
                    },
                    {
                      TI_texttableentry: 'TI_Permanently',
                      interval: '1',
                      texttableentry: 'Permanently',
                    },
                    { TI_texttableentry: 'TI_Cycled', interval: '2', texttableentry: 'Cycled' },
                    {
                      TI_texttableentry: 'TI_ConfiguredCycle',
                      interval: '4',
                      texttableentry: 'ConfiguredCycle',
                    },
                  ],
                  path: 'PA_Struc/PA_CircuPumpMode',
                  unit: '',
                  translationid: 'TI_CirculationPumpMode',
                  bitposition: '0',
                  name: 'PA_CircuPumpMode',
                  value: 'TimeScheduled',
                },
                {
                  semantic: 'BOOLEANCHOICE',
                  longname: 'ParallelLegionella',
                  byteposition: '1',
                  dopname: '1 Byte TextTable NoYes',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_ParalLegio',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                    { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                  ],
                  path: 'PA_Struc/PA_ParalLegio',
                  unit: '',
                  translationid: 'TI_ParallelLegion',
                  bitposition: '0',
                  name: 'PA_ParalLegio',
                  value: 'No',
                },
                {
                  semantic: 'BOOLEANCHOICE',
                  longname: 'ParallelDomesticHotWater',
                  byteposition: '2',
                  dopname: '1 Byte TextTable NoYes',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_ParalDomesHotWater',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                    { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                  ],
                  path: 'PA_Struc/PA_ParalDomesHotWater',
                  unit: '',
                  translationid: 'TI_ParallelDomesticHotWater',
                  bitposition: '0',
                  name: 'PA_ParalDomesHotWater',
                  value: 'No',
                },
                {
                  semantic: 'ENUMCHOICE',
                  longname: 'CycleConfiguration',
                  byteposition: '3',
                  dopname: '1 Byte TextTable CycleConfiguration',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_CycleConfi',
                  constraints: '',
                  structure: [
                    {
                      TI_texttableentry: 'TI_OneCycle',
                      interval: '0',
                      texttableentry: 'OneCycle',
                    },
                    {
                      TI_texttableentry: 'TI_TwoCycles',
                      interval: '1',
                      texttableentry: 'TwoCycles',
                    },
                    {
                      TI_texttableentry: 'TI_ThreeCycles',
                      interval: '2',
                      texttableentry: 'ThreeCycles',
                    },
                    {
                      TI_texttableentry: 'TI_FourCycles',
                      interval: '3',
                      texttableentry: 'FourCycles',
                    },
                    {
                      TI_texttableentry: 'TI_FiveCycles',
                      interval: '4',
                      texttableentry: 'FiveCycles',
                    },
                    {
                      TI_texttableentry: 'TI_SixCycles',
                      interval: '5',
                      texttableentry: 'SixCycles',
                    },
                  ],
                  path: 'PA_Struc/PA_CycleConfi',
                  unit: '',
                  translationid: 'TI_CycleConfiguration',
                  bitposition: '0',
                  name: 'PA_CycleConfi',
                  value: 'OneCycle',
                },
                {
                  semantic: 'VALUEWRITE',
                  longname: 'TriggerCycleDuration',
                  byteposition: '4',
                  dopname: '1 Byte Identical uint8 Minute',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_TriggCycleDurat',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_TriggCycleDurat',
                  unit: 'min',
                  translationid: 'TI_TriggerCycleDuration',
                  bitposition: '0',
                  name: 'PA_TriggCycleDurat',
                  value: '0',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
